export default "__VITE_ASSET__DfpBH8R1__"